import { useEffect } from 'react';

// Allows parent containers to reset the filters
export const useResetFilters = (resetFiltersRef, resetFilters) => {
  useEffect(() => {
    if (resetFiltersRef && resetFiltersRef.current !== resetFilters) {
      resetFiltersRef.current = resetFilters;
    }
  }, [resetFiltersRef, resetFilters]);
};
